import { InfoIcon } from '@change/ds-icons';

import { Avatar, Card, Link, Text } from '@change/ds-core-ui/next';

import { useDecisionMakers } from '../../hooks/useDecisionMakers';
import { DecisionMakerResponse } from '../DecisionMakerResponse';

export const PrimaryDecisionMakers: React.FC = () => {
	const {
		data: { primaryDMs },
	} = useDecisionMakers();

	return primaryDMs.map((dm) => {
		const { photoUrl, displayName, publiclyVisible, slug, id, title, location, signersText, response } = dm;

		return (
			<Card key={id} className="mb-6 p-6">
				<div className="flex items-center gap-4">
					<Avatar src={photoUrl || undefined} alt={displayName} size="x-large" className="flex-shrink-0" />

					<div className="flex-1">
						{publiclyVisible ? (
							<Link
								bold
								data-qa="dm-link"
								href={`/decision-makers/${slug || id}?source_location=petition_details_gamma_legislative_bodies`}
								className="mr-2"
							>
								<Text variant="heading" size="x-small">
									{displayName}
								</Text>
							</Link>
						) : (
							<Text variant="heading" size="x-small" className="mr-2">
								{displayName}
							</Text>
						)}

						<Text variant="body" className="text-muted mb-2 mr-2 text-sm">
							{location ? `${title}, ${location}` : `${title}`}
						</Text>
						<InfoIcon className="text-icon-weaker" size="small" />
						<Text as="div" className="text-muted mb-2">
							{signersText}
						</Text>
						<div>
							<DecisionMakerResponse response={response} />
						</div>
					</div>
				</div>
			</Card>
		);
	});
};
